import axios from 'axios';
import { UpdateTreatmentInput } from '../types/update-treatment-input.type';

// PUT TREATMENT
// /ewosapi/v1/shrimps/Treatment/{globalCompanyId}/treatmentId
export const putTreatment = async (globalCompanyId: string, treatmentId: number, request: UpdateTreatmentInput) => {
  const res = await axios.put(`/ewosapi/v1/shrimps/Treatment/${globalCompanyId}/${treatmentId}`, request);
  return res.data;
};
